import React from 'react';
import { Button, Container } from 'react-bootstrap';
import SparePartsPricingTable from '../../../components/tables/SparePartsPricingTable/SparePartsPricingTable';
import './SparePartsPricing.css';
import { Link } from 'react-router-dom';

const SparePartsPricing = () => {
    return (
        <Container fluid>
            <div className="spare-parts-pricing-page mt-5 mb-5">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                        <h3 className="mb-0">Spare Parts Pricing</h3>
                        <p className="text-muted small mb-0">Grouped by vehicle and variant. Active cars appear first; legacy cars are shown at the bottom.</p>
                    </div>
                    <Link to="/spare-parts-management/spare-parts-pricing/add">
                        <Button variant="primary">Add Spare Part</Button>
                    </Link>
                </div>
                <SparePartsPricingTable />
            </div>
        </Container>

    );
};

export default SparePartsPricing;
